import { render, staticRenderFns } from "./BannerTeaser.vue?vue&type=template&id=3f8c95dc&shadow"
import script from "./BannerTeaser.vue?vue&type=script&lang=ts&shadow"
export * from "./BannerTeaser.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./BannerTeaser.vue?vue&type=style&index=0&id=3f8c95dc&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports